import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import * as React from "react";

import { TernaryFilterOption } from "../../types/index";
import ToggleButtonGroup from "../ToggleButtonGroup";

interface Props {
  title: string;
  filterState: TernaryFilterOption;
  onChange: (filterState: TernaryFilterOption) => void;
  disabled?: boolean;
}

class GenericTernaryButtonGroupFilter extends React.Component<Props> {
  private isOptionSelected = (filterSelected: TernaryFilterOption): boolean =>
    this.props.filterState === filterSelected;

  private buttons = [
    {
      label: "egal",
      selected: () => this.isOptionSelected(TernaryFilterOption.DISREGARD),
      onClick: () => this.props.onChange(TernaryFilterOption.DISREGARD),
    },
    {
      label: <CheckIcon />,
      selected: () => this.isOptionSelected(TernaryFilterOption.INCLUDE),
      onClick: () => this.props.onChange(TernaryFilterOption.INCLUDE),
    },
    {
      label: <ClearIcon />,
      selected: () => this.isOptionSelected(TernaryFilterOption.REJECT),
      onClick: () => this.props.onChange(TernaryFilterOption.REJECT),
    },
  ];

  public render() {
    return (
      <ToggleButtonGroup
        title={this.props.title}
        buttons={this.buttons}
        disabled={this.props.disabled}
      />
    );
  }
}

export default GenericTernaryButtonGroupFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/GenericTernaryButtonGroupFilter.tsx